const setHeaderText = (name) => {
  const $headerTextNode = document.querySelector('#header-text');
  $headerTextNode.textContent = `${name}`;
}

export default {
  setHeaderText,
}
